module.exports = "/components/components/selectGroupComponent-518232.html";